const displayConditionOperator = {
    EQUALS : 0,

    NOT_EQUALS : 1,

    NOT_EMPTY : 2,

    EMPTY_VALUE_SET : 3,

    NOT_EMPTY_VALUE_SET : 4

};

angular.module('gw-um-j2js')
    .constant('displayConditionOperator', displayConditionOperator);